<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from '../../../../services/i18n';
	import { gen2Request } from '../../../../services/gen_2_http_reqs';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	//Stores
		//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';
	//Design system components
	import { Button, Input } from '@Shelly/shelly-design-system';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';

	$: settingsStore = getDeviceSettings(id);
	export let device;

	const id = real_id(device.id);

	let settings = $settingsStore;
	let value = settings?.['input:0']?.name;
	let cache = value;
	let loading = false;

	const save_name = async () => {
		if (cache !== value && value !== '') {
			loading = true;
			const params = {
				id: device.channel,
				config: { name: value },
			};

			const res: SettingRequest = await gen2Request(device, 'input.SetConfig', params);
			const response = onSettingsResponse(res, device);

			if (response) {
				settings['input:0'].name = value;
				devices_settings.update_devices_settings(id, settings);
				cache = value;
			} else {
				value = cache;
			}
			loading = false;
		}
	};
</script>

<Input
	size="m"
	class="mb-s"
	label={$format('sub_settings_title_input_name', { default: 'Input name' })}
	bind:value
	on:enter={save_name}
	id="input-k4clpk2"
	aria-labelledby="input-k4clpk2"
/>
<Button class="mt-s" {loading} size="m" width="full" on:click={save_name}
	>{$format('button_save')}</Button
>
